import { create } from 'zustand';

type OnboardingDialogState = {
  isOpen: boolean;
  // Bumped on each open so the conversation remounts and re-fetches.
  sessionKey: number;
  /** Unsent composer text. Held here because closing the panel unmounts the composer. */
  draft: string;
  open: () => void;
  close: () => void;
  setDraft: (draft: string) => void;
};

export const useOnboardingDialogStore = create<OnboardingDialogState>((set) => ({
  isOpen: false,
  sessionKey: 0,
  draft: '',
  open: () => set((state) => ({ isOpen: true, sessionKey: state.sessionKey + 1 })),
  close: () => set({ isOpen: false }),
  setDraft: (draft) => set({ draft }),
}));
